var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"welcomePart",staticClass:"scroll-item welcome-part",attrs:{"id":"welcome-part"}},[_c('p',{staticClass:"welcome"},[_vm._v(" 歡迎來到 ")]),_c('p',{staticClass:"welcome"},[_vm._v(" 湖口人 ")]),_c('p',{staticClass:"welcome"},[_vm._v(" 幻想世界 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }